export const login = (token) => {
    localStorage.setItem('token', token);
};

export const logout = () => {
    localStorage.removeItem('token');
};

const getToken = () => localStorage.getItem('token');

const parseJwtPayload = (token) => {
    try {
        const payloadBase64 = token.split('.')[1];
        if (!payloadBase64) return null;

        const base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );

        return JSON.parse(json);
    } catch {
        return null;
    }
};

export const isLoggedIn = () => {
    const token = getToken();
    if (!token) return false;

    const payload = parseJwtPayload(token);

    // Opaque/non-JWT token (no parseable payload) — treat as valid
    if (!payload) return true;

    // No exp claim — no expiry enforced
    if (!payload.exp) return true;

    const isExpired = Date.now() >= payload.exp * 1000;
    if (isExpired) {
        logout();
        return false;
    }
    return true;
};